import _toConsumableArray from "C:/WORK/AIWORK/VUEGEN/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  "class": "header modulewrap"
};
var _hoisted_2 = {
  "class": "nav"
};
var _hoisted_3 = {
  "class": "logo"
};
var _hoisted_4 = {
  "class": "navmain"
};
var _hoisted_5 = {
  "class": "banner"
};
var _hoisted_6 = ["src"];
export default {
  __name: 'Cheader',
  setup: function setup(__props) {
    var _getCurrentInstance = getCurrentInstance(),
      proxy = _getCurrentInstance.proxy;
    var FFdata = reactive({
      isHome: true,
      listNav: [],
      listBanner: []
    });
    var CisHome = computed(function () {
      return !proxy.$store.navAlias;
    });
    var ChomeBanner = computed(function () {
      var banner = '';
      proxy.$common.each(FFdata.listBanner, function (item) {
        banner += ',' + item.imgs;
      });
      return banner ? banner.substring(1) : '';
    });
    var Cbanner = computed(function () {
      var banner = '';
      proxy.$common.each(FFdata.listNav, function (item) {
        if (item.alias == proxy.$store.navAlias) {
          banner = item.imgs;
        }
      });
      return banner;
    });
    var getData = function getData() {
      proxy.$common.fetch({
        'act': 'gen_navinfo',
        msg: ''
      }, function (res) {
        FFdata.listNav = res.infodata;
        FFdata.listBanner = res.infodatabanner;
      });
    };
    onMounted(function () {
      getData();
    });
    onUnmounted(function () {});
    return function (_ctx, _cache) {
      var _component_ffimg = _resolveComponent("ffimg");
      var _component_router_link = _resolveComponent("router-link");
      var _component_ffswiper = _resolveComponent("ffswiper");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        "class": _normalizeClass(['navwrap', _unref(CisHome) ? 'fixed' : ''])
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        "default": _withCtx(function () {
          return [_unref(CisHome) ? (_openBlock(), _createBlock(_component_ffimg, {
            key: 0,
            alias: "gen_logohome"
          })) : (_openBlock(), _createBlock(_component_ffimg, {
            key: 1,
            alias: "gen_logosub"
          }))];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("dl", null, [_createElementVNode("dd", {
        "class": _normalizeClass({
          cs: _unref(CisHome)
        })
      }, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        "default": _withCtx(function () {
          return _toConsumableArray(_cache[0] || (_cache[0] = [_createTextVNode("首页", -1)]));
        }),
        _: 1
      }), _cache[1] || (_cache[1] = _createElementVNode("span", {
        "class": "navline"
      }, null, -1))], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listNav, function (item) {
        return _openBlock(), _createElementBlock("dd", {
          key: item.id,
          "class": _normalizeClass({
            cs: item.alias == _ctx.$store.navAlias
          })
        }, [_createVNode(_component_router_link, {
          to: item.url
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(item.title), 1)];
          }),
          _: 2
        }, 1032, ["to"]), _cache[2] || (_cache[2] = _createElementVNode("span", {
          "class": "navline"
        }, null, -1))], 2);
      }), 128))])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        "class": "navlogin"
      }, "登录 | 注册", -1))])], 2), _createElementVNode("div", _hoisted_5, [_unref(CisHome) ? (_openBlock(), _createBlock(_component_ffswiper, {
        key: 0,
        imgs: _unref(ChomeBanner)
      }, null, 8, ["imgs"])) : _unref(Cbanner) ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _unref(Cbanner)
      }, null, 8, _hoisted_6)) : _createCommentVNode("", true)])]);
    };
  }
};